import React, { useState,memo } from 'react'

const Skeleton = () => {
  const [selected, setSelected] = useState(0)
    const [load, setLoad] = useState(false)
    const RadioBtn = memo(({ active, select, index }) => {
        return (
            <div className="m-1 cursor-pointer" onClick={() => { select(index) }}>
                <img src={`/gallery_page/radio_${active ? "selected" : "default"}.svg`} />
            </div>
        )
    })
  return (
    <div className="flex flex-col justify-center m-4 animate-pulse ">
      <img src="/gallery_page/loading.png" className="animate-pulse rounded-t-3xl" />
      <h4 className="line-clamp-1 font-barlow-normal p-2 text-center text-lg bg-gray-300 animate-pulse "></h4>
      <div className="animate-pulse  bg-gradient-to-r h-8 flex from-white items-center justify-center rounded-b-full to-white via-gray-200">
        {/* <RadioBtn className="cursor-pointer" active={selected === 0 ? true : false} index={0} select={setSelected} />
        <RadioBtn className="cursor-pointer" active={selected === 1 ? true : false} index={1} select={setSelected} />
        <RadioBtn className="cursor-pointer" active={selected === 2 ? true : false} index={2} select={setSelected} /> */}
      </div>
    </div>
  )
}

export default Skeleton